import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: '/admin/carriers/settings/callerid',
            data: {
                data: [],
                metadata: []
            },
            metadata: [
                    {
                        'label': 'id',
                        'source': 'ATRCALLERIDREWRITEGROUPID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Caller ID Group Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New caller ID group...'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        label: 'View',
                        value: '/carriers/settings/callerid/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "Carrier Caller ID Groups">
                <Resource data = {data} {...this.props} addButtonValue="Add Caller ID Group" />
            </Panel>
        )
    }
}       

